import React from "react";
import { NavLink } from "react-router-dom";
import { Nav, Collapse } from "reactstrap";
// react plugin for creating notifications over the dashboard
import NotificationAlert from "react-notification-alert";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";

import { Button } from "components";

import avatar from "assets/img/smile.png";
//import logo from "logo-white.svg";
import logo from "assets/img/favicon.png";
import { Badge } from "antd";

var ps;
const DEBUG_MODE = window.location.host.includes("localhost");

class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openAvatar: false,
      openComponents: this.activeRoute("/components") !== "" ? true : false,
      openForms: this.activeRoute("/forms") !== "" ? true : false,
      openTables: this.activeRoute("/tables") !== "" ? true : false,
      openMaps: this.activeRoute("/maps") !== "" ? true : false,
      openPages: this.activeRoute("/pages") !== "" ? true : false,
      openWeb: this.activeRoute("/web") !== "" ? true : false,
      openCalendars:
        this.activeRoute("/calendarios") !== "" ||
        this.activeRoute("/recordatorios") !== ""
          ? true
          : false,
      openBillings: this.activeRoute("/facturas") !== "" ? true : false,
    };
    this.activeRoute.bind(this);
    this.minimizeSidebar = this.minimizeSidebar.bind(this);
    this.getIcon = this.getIcon.bind(this);
    this.setSidebarMinimized = this.setSidebarMinimized.bind(this);
    this.getSidebarMinimized = this.getSidebarMinimized.bind(this);
    this.syncSidebarStatus = this.syncSidebarStatus.bind(this);
    this.toggleSidebarMinimized = this.toggleSidebarMinimized.bind(this);

    this.syncSidebarStatus();
  }
  // verifies if routeName is the one active (in browser input)
  activeRoute(routeName) {
    // console.log("pathname", this.props.location.pathname);
    // console.log("routeName", routeName);
    // return this.props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
    return this.props.location.pathname === routeName ? "active" : "";
  }
  toggleSidebarMinimized() {
    this.setSidebarMinimized(!this.getSidebarMinimized());
    this.syncSidebarStatus();
  }
  setSidebarMinimized(minimized) {
    // Minimized can be 0 or 1 (false/true)
    if (minimized && minimized !== 0) {
      minimized = "1";
    } else {
      minimized = "0";
    }
    localStorage.setItem("sidebar_minimized", minimized);
  }
  getSidebarMinimized() {
    return localStorage.getItem("sidebar_minimized") === "1";
  }
  minimizeSidebar() {
    this.toggleSidebarMinimized();
    // var message = "Barra lateral mini ";
    // if (document.body.classList.contains("sidebar-mini")) {
    //   message += "desactivada";
    // } else {
    //   message += "activada";
    // }
    // document.body.classList.toggle("sidebar-mini");
    // var options = {};
    // options = {
    //   place: "tr",
    //   message: message,
    //   type: "info",
    //   icon: "now-ui-icons ui-1_bell-53",
    //   autoDismiss: 7
    // };
    // this.props.showNotification(options);
  }
  syncSidebarStatus() {
    // console.log("Syncing sidebar status");
    let realMinimized = document.body.classList.contains("sidebar-mini");
    let savedMinimized = this.getSidebarMinimized();
    // console.log("real/saved", realMinimized + "/" + savedMinimized);
    if (realMinimized !== savedMinimized)
      document.body.classList.toggle("sidebar-mini");
  }
  componentDidUpdate() {
    this.syncSidebarStatus();
  }
  componentDidMount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(this.refs.sidebar, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
    }
    /* this.props.setNotificationController(this.refs.notificationAlert); */
  }
  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
    }
    // to stop the warning of calling setState of unmounted component
    var id = window.setTimeout(null, 0);
    while (id--) {
      window.clearTimeout(id);
    }
  }
  getIcon(element, icon) {
    switch (element) {
      case "Facturas":
        if (!this.props.mainState.ordersLoaded) {
          icon = "arrows-1_refresh-69 spin";
        }
        break;
      case "Móvil":
        if (!this.props.mainState.mobilesCDRLoaded) {
          icon = "arrows-1_refresh-69 spin";
        }
        break;
      case "Trámites":
        if (
          !this.props.mainState.mobileProceduresCountLoaded ||
          this.props.mainState.isSearchingMobileProcedures[0]
        ) {
          icon = "arrows-1_refresh-69 spin";
        }
        break;
      case "Clientes":
        if (!this.props.mainState.customersLoaded) {
          icon = "arrows-1_refresh-69 spin";
        }
        break;
      default:
        break;
    }

    return icon;
  }
  render() {
    //console.log("##################### IMPRIMIR MENU SIDEBAR ##################");
    //console.log(this.props.mainState);
    return (
      <div>
        <NotificationAlert ref="notificationAlert" />
        <div className="sidebar" data-color="black">
          <div className="logo">
            <a href="#" className="simple-text logo-mini">
              <div className="logo-img">
                <img src={logo} alt="react-logo" />
              </div>
            </a>
            <a href="#" className="simple-text logo-normal">
              Oficina
            </a>
            <div className="navbar-minimize">
              <Button
                simple
                neutral
                icon
                round
                id="minimizeSidebar"
                onClick={this.minimizeSidebar}
              >
                {/* <i className="now-ui-icons text_align-center visible-on-sidebar-regular" /> */}
                <i className="now-ui-icons ui-1_simple-remove visible-on-sidebar-regular" />
                <i className="now-ui-icons design_bullet-list-67 visible-on-sidebar-mini" />
              </Button>
            </div>
          </div>

          <div className="sidebar-wrapper" ref="sidebar">
            <div className="user">
              <div className="photo">
                <img src={avatar} alt="Avatar" />
              </div>
              <div className="info">
                <a
                  data-toggle="collapse"
                  aria-expanded={this.state.openAvatar}
                  onClick={() =>
                    this.setState({ openAvatar: !this.state.openAvatar })
                  }
                >
                  <span>
                    {this.props.mainState ? this.props.mainState.user.name : ""}
                    {/* <b className="caret" /> */}
                  </span>
                </a>
                {/* <Collapse isOpen={this.state.openAvatar}>
                  <ul className="nav">
                    <li>
                      <a>
                        <span className="sidebar-mini-icon">MP</span>
                        <span className="sidebar-normal">My Profile</span>
                      </a>
                    </li>
                    <li>
                      <a>
                        <span className="sidebar-mini-icon">EP</span>
                        <span className="sidebar-normal">Edit Profile</span>
                      </a>
                    </li>
                    <li>
                      <a>
                        <span className="sidebar-mini-icon">S</span>
                        <span className="sidebar-normal">Settings</span>
                      </a>
                    </li>
                  </ul>
                </Collapse> */}
              </div>
            </div>

            <Nav>
              {this.props.routes.map((prop, key) => {
                if (prop.redirect) return null;
                let notForDigitalDistributors = [
                  "Pages",
                  "Components",
                  "Forms",
                  "Tables",
                  "Maps",
                  "Widgets",
                  "Charts",
                  "Calendar",
                ];
                let notForBecarios = [
                  "Dashboard",
                  "Citas",
                  "Calendario",
                  "Cajas",
                  "Pegasus",
                  "Trámites",
                  "Web",
                  "Solicitudes móvil",
                  "Facturas",
                  "Móvil",
                  "Contratos",
                  "Herramientas",
                  "Tickets",
                ];
                let notForExternals = [
                  "Dashboard",
                  "Cobertura",
                  "Citas",
                  "Calendario",
                  "Cajas",
                  "Pegasus",
                  "Trámites",
                  "Web",
                  "Solicitudes móvil",
                  "Facturas",
                  "Móvil",
                  "Contratos",
                  "Herramientas",
                  "Tickets",
                ];
                let adminUsers = ["Adrian-nadunet", "Ruben-nadunet"];
                let becariosUsers = ["Miguel.Zarzo-nadunet"];
                let externalUsers = ["Oniti"];
                if (
                  this.props.mainState.isTechnician() &&
                  prop.name !== "Citas" &&
                  prop.name !== "Herramientas"
                )
                  return null;
                if (
                  becariosUsers.indexOf(this.props.state.user.name) > -1 &&
                  notForBecarios.indexOf(prop.name) > -1
                )
                  return null;
                if (
                  externalUsers.indexOf(this.props.state.user.name) > -1 &&
                  notForExternals.indexOf(prop.name) > -1
                )
                  return null;
                if (
                  !DEBUG_MODE &&
                  notForDigitalDistributors.indexOf(prop.name) > -1
                )
                  return null;
                if (
                  prop.name === "Pegasus" /* || prop.name === "Herramientas"*/
                ) {
                  if (
                    this.props.state.user.name !== "Adrian-nadunet" &&
                    this.props.state.user.name !== "Ruben"
                  )
                    return null;
                }
                if (
                  prop.name ===
                  "Facturación" /* || prop.name === "Herramientas"*/
                ) {
                  if (!this.props.userData.isBillingDepartmentN1()) return null;
                }
                // if (prop.name === "Citas") {
                //   if (this.props.state.user.name !== "Adrian-nadunet" && this.props.state.user.name !== "Ruben-nadunet") return null;
                // }
                // console.log("############# this.props.state.user.name ############");
                // console.log(this.props.state.user.name);
                let freeFormsCount = this.props.mainState.freeWebformsCount;
                let processingWebformsCount = this.props.mainState
                  .processingWebformsCount;
                if (!freeFormsCount) freeFormsCount = 0;
                if (!processingWebformsCount) processingWebformsCount = 0;
                let webformsCount = freeFormsCount + processingWebformsCount;
                if (prop.collapse) {
                  var st = {};
                  st[prop["state"]] = !this.state[prop.state];
                  return (
                    <li className={this.activeRoute(prop.path)} key={key}>
                      <a
                        data-toggle="collapse"
                        aria-expanded={this.state[prop.state]}
                        onClick={() => this.setState(st)}
                      >
                        {prop.name === "Web" && (
                          <Badge size="small" count={webformsCount}>
                            <span className="menu-with-badge">
                              <i
                                className={
                                  "now-ui-icons " +
                                  this.getIcon(prop.name, prop.icon)
                                }
                              />
                              <p>
                                {prop.name}
                                <b className="caret" />
                              </p>
                            </span>
                          </Badge>
                        )}
                        {prop.name !== "Web" && (
                          <span>
                            <i
                              className={
                                "now-ui-icons " +
                                this.getIcon(prop.name, prop.icon)
                              }
                            />
                            <p>
                              {prop.name}
                              <b className="caret" />
                            </p>
                          </span>
                        )}
                      </a>
                      <Collapse isOpen={this.state[prop.state]}>
                        <ul className="nav">
                          {prop.views.map((prop, key) => {
                            if (prop.redirect) return null;
                            if (prop.name === "Formularios web") {
                              return (
                                <li
                                  className={this.activeRoute(prop.path)}
                                  key={key}
                                >
                                  <NavLink
                                    to={prop.path}
                                    activeClassName="active"
                                  >
                                    <Badge size="small" count={webformsCount}>
                                      <span className="menu-with-badge-sub">
                                        <span className="sidebar-mini-icon">
                                          {prop.mini}
                                        </span>
                                        <span className="sidebar-normal">
                                          {prop.name}
                                        </span>
                                      </span>
                                    </Badge>
                                  </NavLink>
                                </li>
                              );
                            } else if (prop.externalRedirect) {
                              return (
                                <li
                                  className={this.activeRoute(prop.path)}
                                  key={key}
                                >
                                  <a
                                    href={prop.path}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <span className="sidebar-mini-icon">
                                      {prop.mini}
                                    </span>
                                    <span className="sidebar-normal">
                                      {prop.name}
                                    </span>
                                  </a>
                                </li>
                              );
                            } else {
                              return (
                                <li
                                  className={this.activeRoute(prop.path)}
                                  key={key}
                                >
                                  <NavLink
                                    to={prop.path}
                                    activeClassName="active"
                                  >
                                    <span className="sidebar-mini-icon">
                                      {prop.mini}
                                    </span>
                                    <span className="sidebar-normal">
                                      {prop.name}
                                    </span>
                                  </NavLink>
                                </li>
                              );
                            }
                          })}
                        </ul>
                      </Collapse>
                    </li>
                  );
                }
                return (
                  <li className={this.activeRoute(prop.path)} key={key}>
                    <NavLink
                      to={prop.path}
                      className="nav-link"
                      activeClassName="active"
                    >
                      <i
                        className={
                          "now-ui-icons " + this.getIcon(prop.name, prop.icon)
                        }
                      />
                      <p>{prop.name}</p>
                    </NavLink>
                  </li>
                );
              })}
            </Nav>
          </div>
        </div>
      </div>
    );
  }
}

export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.jsx